<template>
	<van-popup v-model="innerVisible" position="bottom" :safe-area-inset-bottom="true">
		<div class="popup-address-wrap">
			<div
				v-for="(item, index) in addressList"
				:key="index"
				class="popup-address-item"
				@click="selectAddress(item)"
			>
				<span>{{ item }}</span>
				<m-svg-icon v-show="item === actionAddress" name="checked" class="popup-address-checked" />
			</div>
			<div class="popup-address-footer">
				<div class="popup-address-confirm" @click="onConfirm">{{ $t('确定') }}</div>
			</div>
		</div>
	</van-popup>
</template>

<script>
import { Popup } from 'vant';

export default {
	components: {
		'van-popup': Popup
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		addressList: {
			type: Array,
			default: () => []
		},
		actionAddress: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			columns: [],
			durationIndex: 0
		};
	},
	computed: {
		innerVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			}
		}
	},
	methods: {
		selectAddress(val) {
			this.$emit('onSelect', val);
			this.innerVisible = false;
		},
		onConfirm() {
			this.innerVisible = false;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../../../style/mixin/mixins.less';
@import '../../../../style/mixin/border-radius.less';

.popup-address-wrap {
	background: #fff;

	.popup-address-item {
		padding: 0.12rem 0.18rem;
		display: flex;
		align-items: center;
		line-height: 0.24rem;
		.thinner-border-bottom(#E8EAEF);

		span {
			flex: 1;
			color: #333;
			/* 15/H5-regular */
			font-family: 'PingFang SC';
			font-size: 0.15rem;
			font-style: normal;
			font-weight: 400;
			word-break: break-all;
		}
		.popup-address-checked {
			margin-left: 0.24rem;
			font-size: 0.24rem;
			color: var(--ir-theme-color);
		}
	}
	.popup-address-footer {
		padding: 0.12rem 0.14rem;

		.popup-address-confirm {
			padding: 0.1rem 0;
			text-align: center;
			color: #fff;
			/* 16/H4-regular */
			font-family: 'PingFang SC';
			font-size: 0.16rem;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 22.4px */
			border-radius: 0.01rem;
			background: var(--ir-theme-color);
		}
	}
}
</style>
